import { create } from "zustand";
import { getStudioPlacesGeoJSON, type PlaceGeoJSON } from "./api";
import { emptyPlacesGeoJSON } from "./mapConstants";

interface PlacesState {
  /** Browsable places (published + user's unlisted) */
  places: PlaceGeoJSON;

  /** Whether places are currently loading */
  loading: boolean;

  /** Load places from the server */
  load: () => Promise<void>;

  /** Reload places (alias for load, for semantic clarity after mutations) */
  reload: () => Promise<void>;
}

export const usePlaces = create<PlacesState>((set, get) => ({
  places: emptyPlacesGeoJSON,
  loading: false,

  load: async () => {
    // Skip if already loading
    if (get().loading) return;

    set({ loading: true });
    try {
      const places = await getStudioPlacesGeoJSON();
      set({ places, loading: false });
    } catch (error) {
      console.error("Failed to load places:", error);
      set({ loading: false });
    }
  },

  reload: async () => {
    // Force reload even if already loaded
    set({ loading: true });
    try {
      const places = await getStudioPlacesGeoJSON();
      set({ places, loading: false });
    } catch (error) {
      console.error("Failed to reload places:", error);
      set({ loading: false });
    }
  },
}));
